import React, { useState, useEffect } from 'react';
import * as chat_helpers from './ChatHelper';

// Import CSS & assets
import './Chat.css';
import logo from '../../../assets/logo.svg';
import ico_arrow_send from '../../../assets/ico/ico_arrow_send.svg';

// Import components
import MessageUser from './MessageUser';
import MessageAssistant from './MessageAssistant';

var messages_legacy = [];



const Chat = ({ capacity, isSectionChatHidden }) => {

    // OPEN / CLOSE SECTION
    useEffect(() => {
        var domitems = document.getElementsByClassName("mapboxgl-ctrl-bottom-right");
        if (domitems.length > 0) {
            if (isSectionChatHidden) {
                domitems[0].classList.remove("mapboxgl-ctrl-bottom-right_slided");
            }
            else {
                domitems[0].classList.add("mapboxgl-ctrl-bottom-right_slided");
            }
        }
        domitems = document.getElementsByClassName("mapboxgl-ctrl-top-right");
        if (domitems.length > 0) {
            if (isSectionChatHidden) {
                domitems[0].classList.remove("mapboxgl-ctrl-top-right_slided");
            }
            else {
                domitems[0].classList.add("mapboxgl-ctrl-top-right_slided");
            }
        }
    }, [isSectionChatHidden]);

    // MESSAGES
    const [messagesData, setMessagesData] = useState({ messages: [], updateTracker: 0 });
    const [streamedText, setStreamedText] = useState("");

    // INPUT
    const [isInputEmpty, setIsInputEmpty] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const sendInput = () => {
        var input_dom = document.getElementById('chat_input_textarea');
        if (input_dom) {
            const user_message = input_dom.value;
            console.log("USER INPUT", user_message);
            // Create system prompt
            if (messages_legacy.length === 0) {
                messages_legacy.push({ role: 'system', content: createSystemPrompt() });
            }
            // Create user message
            messages_legacy.push({ role: 'user', content: user_message });
            setMessagesData({ messages: messages_legacy, updateTracker: (Date.now()).toString() });
            // Reset input
            input_dom.value = "";
            setIsInputEmpty(true);
            // Set loading state
            setIsLoading(true);
            // Send request
            sendRequest(messages_legacy);
        }
    }


    // API
    const sendRequest = async (user_message) => {
        console.log("SEND API");
        var assistant_message = await chat_helpers.sendAPI(user_message, setStreamedText);
        console.log("FINAL MESSAGE", assistant_message);
        // Create assistant message
        if (assistant_message && assistant_message.length > 0) {
            // Create assistant message
            messages_legacy.push({ role: 'assistant', content: assistant_message });
            setMessagesData({ messages: messages_legacy, updateTracker: (Date.now()).toString() });
            // Reset streamed text
            setStreamedText("");
            // Set loading state
            setIsLoading(false);
        }
    }
    const createSystemPrompt = () => {
        console.log("CREATE SYSTEM PROMPT");
        var system_message = "";
        // Context
        system_message = system_message + "Tu es l'assistant de l'application Proplab, nommé 'Proplab AI'. Cette application en ligne est utile pour réaliser des études capacitaires et contextuelles de terrain. L'objectif pour les utilisateurs (promoteurs immobilier, développeurs fonciers par exemple) est d'obtenir de façon rapide et précise le potentiel constructible d'un terrain ainsi que des indicateurs divers sur l'environnement contextuel.";
        system_message = system_message + "\n Tu es là pour aider les utilisateurs à utiliser l'application et répondre à leurs questions sur l'étude capacitaire en cours. Tu dois t'appuyer uniquement sur les données qui te sont fournies, tu ne dois pas inventer. Voici les données concernant l'étude capacitaire en cours :";
        // Capacity elements
        var capacity_elements = "";
        // TITRE
        if (capacity?.title) {
            capacity_elements = capacity_elements + "\n titre : " + capacity.title + ".";
        }
        // DESCRIPTION
        if (capacity?.description) {
            capacity_elements = capacity_elements + "\n description : " + capacity.description + ".";
        }
        // ETAT D'AVANCEMENT
        if (capacity?.step === 0 && !capacity?.city?.title) {
            capacity_elements = capacity_elements + "\n état d'avancement de l'étude : nouvelle étude, l'utilisateur doit sélectionner un secteur géographique (commune, ou adresse) pour continuer.";
        }
        else if (capacity?.step === 0 && capacity?.city?.title) {
            capacity_elements = capacity_elements + "\n état d'avancement de l'étude : nouvelle étude sur la commune de " + capacity?.city?.title + ", l'utilisateur doit sélectionner une ou plusieurs parcelles pour continuer. Tu peux lui proposer de filtrer les parcelles selon ses critères de préférence pour l'aider à identifier celles qui présente un potentiel intéressant.";
        }
        else if (capacity?.step === 1) {
            capacity_elements = capacity_elements + "\n état d'avancement de l'étude : l'étude est en cours sur un terrain sélectionné par l'utilisateur.";
        }
        // ADRESSE
        if (capacity?.landBase?.location?.properties?.housenumber && capacity?.landBase?.location?.properties?.street) {
            capacity_elements = capacity_elements + "\n adresse : " + capacity?.landBase?.location?.properties?.housenumber + " " + capacity?.landBase?.location?.properties?.street + ".";
        }
        if (capacity?.landBase?.location?.properties?.city && capacity?.landBase?.location?.properties?.postcode) {
            capacity_elements = capacity_elements + "\n commune (ville) : " + capacity?.landBase?.location?.properties?.city + " dont le code postal est " + capacity?.landBase?.location?.properties?.postcode + ".";
        }
        // PARCELLES
        if (capacity?.landBase?.lands && capacity?.landBase?.lands.length > 0) {
            capacity_elements = capacity_elements + "\n parcelles : le terrain sélectionné par l'utilisateur est composé de " + (capacity?.landBase?.lands.length === 1 ? " 1 parcelle dont la référence cadastrale est :" : capacity?.landBase?.lands.length + " parcelles dont les références cadastrales sont :");
            capacity.landBase.lands.forEach((land, land_index) => {
                if (land?.properties?.section && land?.properties?.numero) {
                    capacity_elements = capacity_elements + " " + land?.properties?.section + "-" + land?.properties?.numero;
                }
                if (land?.area || land?.properties?.contenance) {
                    capacity_elements = capacity_elements + " (surface = " + (land?.area ? Math.round(land.area) : land?.properties?.contenance) + " m²";
                    if (land?.majic?.denomination_proprietaire && land?.majic?.siren_proprietaire) {
                        capacity_elements = capacity_elements + ", propriétaire = '" + land?.majic?.denomination_proprietaire + "' dont le numéro SIREN est " + land?.majic?.siren_proprietaire + ", pour contacter ce propriétaire il est possible de trouver ses informations sur un site de référencement d'entreprises comme société.com ou pappers.fr via son numéro SIREN";
                    }
                    else {
                        capacity_elements = capacity_elements + ", propriétaire = information non publique car le propriétaire est un particulier, pour obtenir cette infromation il faut en faire une demande écrite au Service de la Publicité Foncière (SPF) le plus proche du lieu de situation de la parcelle";
                    }
                    capacity_elements = capacity_elements + ")";
                }
                if (land_index < capacity.landBase.lands.length - 1) {
                    capacity_elements = capacity_elements + " et ";
                }
                else {
                    capacity_elements = capacity_elements + ".";
                }
            });
        }
        // TERRAIN : SURFACE
        if (capacity?.landBase?.union?.area) {
            capacity_elements = capacity_elements + "\n terrain d'assiette : surface = " + Math.round(capacity?.landBase?.union?.area) + " m².";
        }
        // TERRAIN : LIMITES
        if (capacity?.landBase?.union?.bounds_groups && capacity?.landBase?.union?.bounds_groups.length > 0) {
            var bounds_stats = { way: { length: 0, nb: 0 }, separation: { length: 0, nb: 0 }, total: { length: 0, nb: 0 } };
            capacity?.landBase?.union?.bounds_groups.forEach(bounds_group => {
                if (bounds_group?.context_analysis?.result?.type === "way") {
                    bounds_stats.way.length += bounds_group?.length || 0;
                    bounds_stats.way.nb++;
                }
                if (bounds_group?.context_analysis?.result?.type === "separation") {
                    bounds_stats.separation.length += bounds_group?.length || 0;
                    bounds_stats.separation.nb++;
                }
                bounds_stats.separation.length += bounds_group?.length || 0;
                bounds_stats.total.nb++;
            })
            capacity_elements = capacity_elements + "\n limites du terrain = " + capacity?.landBase?.union?.bounds_groups.length + " limites soit un total de " + bounds_stats.separation.length.toFixed(2) + " mètres linéaire dont " + bounds_stats.way.length.toFixed(2) + " m de linéaire sur voie et " + bounds_stats.separation.length.toFixed(2) + " m de limites séparatives (détail de chaque limite :";
            capacity?.landBase?.union?.bounds_groups.forEach((bounds_group, bounds_group_index) => {
                var long = bounds_group?.length ? bounds_group.length.toFixed(2) : null;
                var type = "indéfini";
                if (bounds_group?.context_analysis?.result?.type === "way") { type = "Limite sur voie" }
                if (bounds_group?.context_analysis?.result?.type === "way" && bounds_group?.context_analysis?.result?.subtype === "public") { type = "Limite sur emprise publique" }
                if (bounds_group?.context_analysis?.result?.type === "way" && bounds_group?.context_analysis?.result?.subtype === "road_private") { type = "Limite sur voie privée" }
                if (bounds_group?.context_analysis?.result?.type === "way" && bounds_group?.context_analysis?.result?.subtype === "road_public") { type = "Limite sur voie publique" }
                if (bounds_group?.context_analysis?.result?.type === "way" && bounds_group?.context_analysis?.result?.subtype === "train") { type = "Limite sur voie de chemin de fer" }
                if (bounds_group?.context_analysis?.result?.type === "way" && bounds_group?.context_analysis?.result?.subtype === "water") { type = "Limite sur cours d'eau" }
                if (bounds_group?.context_analysis?.result?.type === "separation") { type = "Limite séparative" }
                if (bounds_group?.context_analysis?.result?.type === "separation" && bounds_group?.context_analysis?.result?.subtype === "back") { type = "Limite séparative de fond de parcelle" }
                if (bounds_group?.context_analysis?.result?.type === "separation" && bounds_group?.context_analysis?.result?.subtype === "side") { type = "Limite séparative latérale" }
                capacity_elements = capacity_elements + " Limite N°" + (bounds_group_index + 1) + " (" + (long ? "longueur = " + long + " m et " : "") + "type = " + type + ")";
                if (bounds_group_index < capacity?.landBase?.union?.bounds_groups.length - 1) { capacity_elements = capacity_elements + ", " } else { capacity_elements = capacity_elements + ")." }
            })
        }
        system_message = system_message + capacity_elements;

        console.log(system_message);

        return system_message;
    }




    return (
        <div className={`app__chat_container_main ${isSectionChatHidden ? "app__chat_container_main_hidden" : ""}`}>
            <div className="app__chat_container">
                <div className="app__sectiondata_title_container_UI" style={{ paddingLeft: '14px', paddingRight: '14px', marginBottom: '15px' }}>
                    {window.innerWidth > 1050 &&
                        <div className="app__sectiondata_widget_spacer_15"></div>
                    }
                    <div className="app__sectiondata_title_label" onClick={() => { setIsLoading(false) }}>Proplab AI {isLoading && "..."}</div>
                    <div className="app__sectiondata_title_bar"></div>
                </div>
                {/* <div className="app__chat_body_container">
                    CHATBOX HERE
                    </div> */}
                {messagesData.messages.length > 0 ?
                    <div className="app__chat_body_container">
                        {/* EXISTING MESSAGES */}
                        {messagesData.messages.map((message) => {
                            if (message?.role === "user") {
                                return (
                                    <MessageUser message={message} />
                                )
                            }
                            else if (message?.role === "assistant") {
                                return (
                                    <MessageAssistant message={message} />
                                )
                            }
                        })}
                        {/* STREAMED MESSAGE */}
                        <div>STREAM :::::</div>
                        <MessageAssistant message={{ content: streamedText }} />
                    </div>
                    :
                    <div className="app__chat_body_container_start">
                        <div className="app__chat_start_logo">
                            <img src={logo} alt="logo" />
                        </div>
                        <div className="app__chat_start_title">Proplab AI</div>
                        <div className="app__chat_start_text">Proplab AI est là pour vous aider dans l'utilisation de notre logiciel, et répondre à vos questions sur l'étude capacitaire en cours.</div>
                        {/* <div className="app__chat_start_text">Il sera bientôt en mesure d'effectuer des actions</div> */}
                    </div>
                }
                <div className="app__chat_linear_hide"></div>
                <div className="app__chat_prompt_container">
                    <div className="app__chat_prompt_box">
                        <div className="app__chat_prompt_input_box">
                            <textarea id="chat_input_textarea" className="app__chat_prompt_input" disabled={isLoading} rows={"3"} onChange={(e) => { e.target.value.length > 0 ? setIsInputEmpty(false) : setIsInputEmpty(true) }}></textarea>
                        </div>
                        <div className="app__chat_prompt_send_box">
                            <div className={`app__chat_prompt_send_button ${isInputEmpty ? "app__chat_prompt_send_button_locked" : ""}`} onClick={() => { sendInput() }}><img src={ico_arrow_send} /></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Chat;